import * as React from 'react';

import styled, { css } from 'styled-components';

import Button from '@components/actions/button';
import Avatar from '@components/basics/avatar';
import DotsIcon from '@components/basics/icons/dots';

import { uploadImage } from '../../sdk/artists';
import { promiseDelay } from '../../utils/promise-delay';

import LoadingCtrl from '@webapp/controllers/loading';

interface AvatarEditorProps {
  className?: string;
  url?: string;
  smallBtn?: boolean;
  avatarSize?: string;
  onChange: (url: string) => void;
}

export const AvatarEditor: React.FC<AvatarEditorProps> = (props) => {
  const propsUrl = props.url;

  const [url, setUrl] = React.useState(propsUrl || '');
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => setUrl(propsUrl || ''), [propsUrl]);

  const handleFileChange = async (file: File) => {
    setLoading(true);
    if (file.type.startsWith('image')) {
      const uploadResponse = await uploadImage(file, 'avatar');

      await uploadResponse.upload.request
        .then(() => {
          setUrl(uploadResponse.url);
        })
        .then(() => promiseDelay(5000))
        .then(() =>{ 
          props.onChange(uploadResponse.url)
          setLoading(false);
        }
        );
    }
  };

  return (
    <div className={props.className}>
      <Avatar
        className="avatar"
        size={props.avatarSize ? props.avatarSize : '130'}
        src={url}
      />
      <LoadingCtrl
        className={`loading-icon ${loading ? 'loading' : ''}`}
        loading={loading}
        size={props.avatarSize ? `${props.avatarSize}px` : '130px'}
      />
      <Button buttonType="empty" className="btn-add">
        <DotsIcon className="icn-dots" />
        <input
          type="file"
          className="file"
          accept="image/*"
          max="1"
          onChange={(ev) =>
            ev.target.files ? handleFileChange(ev.target.files[0]) : null
          }
        />
      </Button>
    </div>
  );
};

export default styled(AvatarEditor)`
  position: relative;
  width: ${(props) => (props.avatarSize ? `${props.avatarSize}px` : '130px')};
  z-index: 1;

  .loading-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: ${(props) => (props.avatarSize ? `${props.avatarSize}px` : '130px')};
    height: ${(props) =>
      props.avatarSize ? `${props.avatarSize}px` : '130px'};
    border-radius: 50%;

    &.loading {
      background: rgba(255, 255, 255, 0.35);
    }
  }

  .btn-add {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 45px;
    height: 34px;
    cursor: pointer;
    z-index: 0;

    .file {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      opacity: 0;
      z-index: 1;
      width: 45px;
      height: 34px;
    }

    .file,
    .file::-webkit-file-upload-button {
      cursor: pointer;
    }

    .icn-dots {
      z-index: -1;
      pointer-events: none;
      cursor: pointer;
    }

    ${(props) =>
      props.smallBtn
        ? css`
            width: 32px;
            height: 24px;
            right: -5px;

            .icn-dots {
              width: 32px;
              height: 24px;
            }
          `
        : null}
  }
`;
